import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs";
import { catchError } from 'rxjs/operators';
import { BaseRestService } from '../base-rest.service';
import { WebImageUrlModel } from '../../models/entity/web-image-url.model';
import { SessionStorageService } from '../session-storage.service';
import { WebImageUrlSearchRequest } from '../../models/rest/web-image-url/web-image-url-search-request';

@Injectable({
  providedIn: 'root'
})
export class WebImageUrlService extends BaseRestService {
  constructor(protected httpClient: HttpClient, protected sessionStorageService: SessionStorageService) {
    super(httpClient, sessionStorageService);
  }

  getWebImageUrls(): Observable<WebImageUrlModel[]> {
    const url = `/web-image-urls`;
    return this.httpGet<WebImageUrlModel[]>(url).pipe(catchError(this.errorHandler));
  }

  addWebImageUrl(data) {
    const url = `/web-image-urls`;
    return this.httpPost<WebImageUrlModel>(url, data)
      .pipe(catchError(this.errorHandler));
  }

  updateWebImageUrl(id, data): Observable<WebImageUrlModel> {
    const url = `/web-image-urls/${id}`;
    return this.httpPut<WebImageUrlModel>(url, data)
      .pipe(catchError(this.errorHandler));
  }

  deleteWebImageUrl(id) {
    const url = `/web-image-urls/${id}`;
    return this.httpDelete(url).pipe(catchError(this.errorHandler));
  }

  getWebImageUrlsByStoreIdAndCategoryType(storeId, categoryType): Observable<WebImageUrlModel[]> {
    const url = `/web-image-urls/search?store-id=${storeId}&category-type=${categoryType}`;
    return this.httpGet<WebImageUrlModel[]>(url).pipe(catchError(this.errorHandler));
  }

  searchWebImageUrls(request: WebImageUrlSearchRequest): Observable<WebImageUrlModel[]> {
    const url = `/web-image-urls/search`;
    return this.httpPost<WebImageUrlModel[]>(url, request).pipe(catchError(this.errorHandler));
  }
}
